import * as types from 'constants/actionTypes';
import * as Rx from 'rxjs';
const { Observable } = Rx;
const { of, ajax } = Observable;
import * as actions from 'actions/sqcActions';
const apiUrls = require('constants/apiUrls');
import { wowCustomHeader } from '../utils/wowCustomHeadersUtils';
import { getAccessTokenFromState } from 'utils/userManager';

export const indirect = {
  call: (fn, ...args) => fn(...args)
};

export const api = {

  generateSqc: (request, store) => {
    const state = store.getState();
    const accessToken = getAccessTokenFromState(state);

    const wowHeaders = wowCustomHeader(state);

    return ajax({
      url: `${apiUrls.SQC_GENERATE_URL}?macaddress=${request.macaddress}`,
      method: 'GET',
      body: request,
      responseType: '',
      crossDomain: true,
      timeout: apiUrls.API_TIMEOUT,
      headers: {
        ...wowHeaders,
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + accessToken
      }
    });
  }

};

export const generateSqcEpic = (action$, store, call = indirect.call) => action$
  .ofType(types.SQC_GENERATE_STARTED)
  .mergeMap(action => call(api.generateSqc, action.request, store).map(payload => {
    let result = {};
    if (payload.response) {
      result = JSON.parse(payload.response);

      // result.data.certificate.rf.downstream.power.score = 'Fail';
      // result.data.certificate.rf.downstream.snr.score = 'Fail';
      // result.data.certificate.rf.upstream.power.score = 'Fail';
      // result.data.certificate.rf.upstream.snr.score = 'Fail';
    }
    return (actions.sqcGenerateLoadFinished(result, action.orderId));
  }).takeUntil(action$.ofType(types.SQC_GENERATE_STARTED)).catch(error => of(actions.sqcGenerateLoadFailed(error, action.orderId))));



// WEBPACK FOOTER //
// ./src/epics/sqcEpics.js